import { Components, Theme } from '@mui/material'

export const MuiPaper: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  defaultProps: {
    // TODO - remove the elevation variant once all usage is removed
    variant: 'outlined',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.futureTheme.text.default,
      backgroundColor: theme.palette.futureTheme.bg.surface.elevated,
      // MUI paints a dark-mode elevation overlay via --Paper-overlay,
      // which would tint the surface token on elevation Papers
      backgroundImage: 'none',
    }),
    outlined: ({ theme }) => ({
      borderWidth: theme.futureTheme.strokeWidth.default,
      borderStyle: 'solid',
      borderColor: theme.palette.futureTheme.border.subtle,
    }),
    rounded: ({ theme }) => ({
      borderRadius: theme.shape['futureTheme.radius-md'],
    }),
  },
}
